import { Payment } from "../types/Payment";

export function isPayment(payment: any): payment is Payment {
  const hasAmount = payment.amount;
  const hasPaymentStatusId = payment.paymentStatusId && typeof payment.paymentStatusId === "number";
  const hasTransactionId = payment.transactionId && typeof payment.transactionId === "number";
  const hasAgreementId = payment.agreement?.id && typeof payment.agreement.id === "number";
  if (hasAmount && hasPaymentStatusId && hasTransactionId && hasAgreementId) {
    return true;
  }
  return false;
}
